module.exports = __webpack_public_path__ + "assets/assets/images/about/sidebar.7a3dd1d1.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/about/sidebar.png
// module id = 549
// module chunks = 0